import React, { createRef } from 'react';
import { IonModal, IonSelect, IonTextarea, IonInput, IonSelectOption, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/ExportImportModal.scss';
import '../styles/Flashcard.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SQLStorage from '../SQLStorage';
import { close, help, helpCircle } from 'ionicons/icons'
import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import { Filesystem, Encoding, Directory } from '@capacitor/filesystem';
import { Clipboard } from '@capacitor/clipboard';
import { Device } from '@capacitor/device';
import { Share } from '@capacitor/share';

class ExportImportModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            studyset: null,
            cards: null,
            termDefinitionSeparator: 'Tab',
            rowSeparator: "New Line",
            raw: "",
            copyToClipboardText: window.ln.copyToClipboard,
            generateFileText: window.ln.generateFileText,
            newCards: [],
            importing: false,
            status: null,
            open: false,
            progressProcessed: 0,
            progressTotal: 0,
            exportType: "Plain Text",
            deviceInfo: {},
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.currentType) {

            this.setState({
                studysetId: nextProps.id,
            }, function() {
                this.load();
            })

        } else {

            this.setState({
                open: false,
                studysetId: false,
                raw: "",
                termDefinitionSeparator: 'Tab',
                rowSeparator: "New Line",
                status: null,
                importing: false,
                progressProcessed: 0,
                progressTotal: 0
            })

        }

    }

    async import() {

        if (this.state.importing) {
            return;
        }

        if (!window.activated && this.state.newCards.length + this.state.cards.length > 499) {
            window.showSubscriptionModal("setcards");
            return;
        }

        if (this.state.newCards.length === 0) {
            this.setState({
                status: {
                    success: false,
                    data: window.ln.importPaste,
                }
            })
            return
        }

        if (this.state.newCards.length + this.state.cards.length > 3000) {
            this.setState({
                status: {
                    success: false,
                    data: window.ln.setTotalLimitReached,
                }
            })
            return
        }

        Utilities.trackEvent("Studyset", "Studyset Clipboard Import", this.state.studyset.id + "|" + this.state.studyset.name, this.state.newCards.length);

        this.setState({
            importing: true
        }, async function() {

            let queueForUploadList = [];

            await SQLStorage.saveCard(this.state.newCards, true, true);

            for (var i = 0; i < this.state.newCards.length; i++) {
                let card = this.state.newCards[i];
                await queueForUploadList.push(["card", card.id + "-" + card.setId]);
            }

            await window.dropbox.queueForUpload(queueForUploadList);

            this.setState({
                importing: false
            }, function() {
                if (window.location.href.indexOf("/justcreated") !== -1) {
                    window.location.href = window.location.href.replace("/justcreated", "");
                } else {
                    store.dispatch(updatedSetsSet([this.state.studyset.id]))
                    this.props.onClose();
                }
            })

        })

    }

    input() {

        let raw = this.state.raw;

        let separatorRowRaw = this.state.rowSeparator;
        let separatorTermDefinitionRaw = this.state.termDefinitionSeparator;

        if (separatorRowRaw.toLowerCase() === "new line")
            separatorRowRaw = "\n"
        else if (separatorRowRaw.toLowerCase() === "tab")
            separatorRowRaw = "\t"

        if (separatorTermDefinitionRaw.toLowerCase() === "new line")
            separatorTermDefinitionRaw = "\n"
        else if (separatorTermDefinitionRaw.toLowerCase() === "tab")
            separatorTermDefinitionRaw = "\t"

        let newCards = [];

        let rows = raw.split(separatorRowRaw);

        let milliseconds = 0;
        let now = new Date();
        now = Utilities.dateSub(now, "second", 3);

        let id = Math.round((new Date()).getTime());

        for (let i = 0; i < rows.length; i++) {

            let row = rows[i].split(separatorTermDefinitionRaw);

            if (row[0] || row[1]) {

                id++;

                newCards.push({
                    id: "" + id + Utilities.randomStr(6),
                    term: row[0] || "",
                    definition: row[1] || "",
                    tags: [],
                    createdAt: new Date(now),
                    updatedAt: new Date(now),
                    setId: this.props.id,
                })

                milliseconds++;
                if (milliseconds === 1000) {
                    milliseconds = 0;
                    now = Utilities.dateAdd(now, "second", 1);
                }
                now.setMilliseconds(milliseconds)

            }

        }

        this.setState({
            newCards: newCards,
            status: {
                success: true,
                data: window.ln.importPreviewStatus.replace("__", newCards.length).replace("___", this.state.cards.length),
            }
        })

    }

    output(termDefinitionSeparatorOverride, rowSeparatorOverride) {

        let raw = "";

        let separatorRowRaw = rowSeparatorOverride || this.state.rowSeparator;
        let separatorTermDefinitionRaw = termDefinitionSeparatorOverride || this.state.termDefinitionSeparator;

        if (separatorRowRaw.toLowerCase() === "new line")
            separatorRowRaw = "\n"
        else if (separatorRowRaw.toLowerCase() === "tab")
            separatorRowRaw = "\t"

        if (separatorTermDefinitionRaw.toLowerCase() === "new line")
            separatorTermDefinitionRaw = "\n"
        else if (separatorTermDefinitionRaw.toLowerCase() === "tab")
            separatorTermDefinitionRaw = "\t"

        for (let i = 0; i < this.state.cards.length; i++) {
            raw += this.state.cards[i].term + separatorTermDefinitionRaw + this.state.cards[i].definition;
            if (i < this.state.cards.length - 1 )
                raw += separatorRowRaw;
        }

        this.setState({ raw: raw })

        return raw;

    }

    async load() {

        let studyset = await SQLStorage.getStudyset(this.props.id);

        if (!studyset) {
            localStorage.setItem("preventAppOpenTrack", "true")
            window.location.href = "/"
            return;
        }

        let cards = await SQLStorage.getAllCardsFromStudyset(this.props.id, "createdAt", "ASC");

        this.setState({
            cards: cards,
            studyset: studyset,
            open: true,
        }, function() {
            if (this.props.currentType === "export") {
                this.output();
            }
        })

    }

    async getCardsFromLocal(ids) {
        let cards = [];
        for (let i = 0; i < ids.length; i++) {
            let card = await Storage.getO("card-" + ids[i]);
            if (card) cards.push(card)
        }
        return cards
    }

    convertCardToJSON(card) {
        delete card.updatedAtTimestamp;
        delete card.history;
        delete card.recording;
        delete card.deleted;
        delete card.customText1
        card.customFields = card.customText2;
        delete card.customText2
        card.images = card.image;
        card.starred = card.star ? true : false;
        delete card.star
        delete card.image
        delete card.customInt1
        delete card.customInt2
        for (let j = 0; j < card.tags.length; j++) {
            const tag = this.props.tags.find(item => item.id === card.tags[j]);
            if (!tag || tag.name === "studying" || tag.name === "mastered" || tag.name === "recording" || tag.name === "image" || tag.name === "new" || tag.name === "star" || tag.name === "learnt") {
                card.tags.splice(j, 1);
                j--;
            } else {
                card.tags[j] = {
                    id: tag.id,
                    name: tag.name,
                    color: tag.color
                }
            }
        }
        if (card.tags === "")
            card.tags = [];
        return card;
    }

    async generateFile() {

        this.setState({ copyToClipboardText: window.ln.generatatingFile });

        let fileName = ("Flashcard Export (" + this.state.studyset.name + ")") + this.state.exportType.toLowerCase();
        let fileContent = "";
        let mimeType = "";
        let mimeTypeDesktop = "";

        Utilities.trackEvent("Studyset", "Studyset " + (this.state.exportType.toUpperCase() + " Export"), this.state.studyset.id + "|" + this.state.studyset.name, this.state.cards.length);

        if (this.state.exportType === ".JSON") {
            let cards = JSON.parse(JSON.stringify(this.state.cards));
            for (let i = 0; i < cards.length; i++) {
                cards[i] = this.convertCardToJSON(cards[i]);
                if (cards[i].links.length !== 0) {
                    let convertedLinkedCards = [];
                    let linkedCards = await SQLStorage.getCardsByIds(cards[i].links, true);
                    for (let k = 0; k < linkedCards.length; k++) {
                        convertedLinkedCards.push(this.convertCardToJSON(linkedCards[k]))
                    }
                    cards[i].links = convertedLinkedCards;
                }
            }
            fileContent = JSON.stringify(cards);
            mimeTypeDesktop = "data:application/json;charset=utf-8,"
            mimeType = "application/json";
        } else if (this.state.exportType === ".TXT") {
            fileContent = this.output();
            mimeType = "text/plain"
            mimeTypeDesktop = "data:text/plain;charset=utf-8,"
        } else if (this.state.exportType === ".CSV") {
            fileContent = ""; //  this.output("n", "\n");
            this.state.cards.map(item => ["'" + item.term + "'", "'" + item.definition + "'"]).forEach(function(rowArray) {
                let row = rowArray.join(",");
                fileContent += row + "\r\n";
            });
            mimeType = "text/csv"
            mimeTypeDesktop = "data:text/csv;charset=utf-8,"
        }

        if (this.state.deviceInfo.platform === "ios" || this.state.deviceInfo.platform === "android" ) {
            await Filesystem.writeFile({ path: fileName, data: fileContent, directory: Directory.Data, encoding: Encoding.UTF8 }).catch(e => {
                console.error("Failed to write file", e)
                window.toast(window.ln.smFileError, "error");
                this.setState({ loading: null });
            })
            
            let uri = await Filesystem.getUri({ directory: Directory.Data, path: fileName });

            Share.share({
                files: [uri.uri],
                title: fileName,
            })
        } else {
            var dataStr = mimeTypeDesktop +  "" + encodeURIComponent(fileContent);
            var downloadAnchorNode = window.document.createElement('a');
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", fileName);
            window.document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        }

        this.setState({ generateFileText: window.ln.generateFileText });

    }

    copyToClipboard() {
        Utilities.trackEvent("Studyset", "Studyset Clipboard Export", this.state.studyset.id + "|" + this.state.studyset.name, this.state.cards.length);
        Clipboard.write({ string: this.state.raw });
        this.setState({ copyToClipboardText: window.ln.copied })
        setTimeout(function() { this.setState({ copyToClipboardText: window.ln.copyToClipboard }) }.bind(this), 3000)
    }

    async componentDidMount() {
        let deviceInfo = await Device.getInfo();
        this.setState({ deviceInfo: deviceInfo })
    }

    render() {
        return (
            <IonModal
                isOpen={this.state.open}
                swipeToClose={false}
                ref={this.entryModalRef}
                presentingElement={this.props.presentingElement ? this.props.presentingElement.current : null}
                onDidDismiss={() => {
                    if (!this.state.importing)
                        this.props.onClose();
                }}
                mode={"ios"}
           >
                { (this.state.open) &&
                   <div className="swipeable-drawer-body" data-drawer="export-import" className="export-import-modal">
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>{Utilities.capitalize(this.props.currentType)} {window.ln.cards}</IonTitle>
                                <IonButtons slot="end">
                                    <IonIcon style={{ width: 24, height: 24, marginRight: 8, marginTop: -3, color: "#333" }} icon={close} onClick={() => { this.props.onClose() }} />
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                       <div className="options">
                           <IonList>
                               { this.props.currentType === "import" &&
                                    <IonItem onClick={() => { this.props.onClose(); this.props.history.push("/help/import"); }}>
                                        <IonIcon icon={helpCircle} style={{ marginRight: 8 }} /> {window.ln.howQuizlet}
                                    </IonItem>
                               }
                               { this.props.currentType === "export" &&
                                    <IonItem>
                                        <IonLabel>{window.ln.exportType}</IonLabel>
                                        <IonSelect 
                                            onIonChange={ async (i) => {
                                                if (i.detail.value === ".PDF") {
                                                    this.props.openPrintModal();
                                                } else {
                                                    this.setState({ exportType: i.detail.value }) 
                                                }
                                            }} 
                                            value={this.state.exportType}
                                        >
                                            { [
                                                {
                                                    type: "Plain Text"
                                                },
                                                {
                                                    type: ".TXT"
                                                },
                                                {
                                                    type: ".JSON"
                                                },
                                                {
                                                    type: ".CSV"
                                                },
                                                {
                                                    type: ".PDF"
                                                },
                                            ].map((item, i) => {
                                                return (
                                                    <IonSelectOption 
                                                        key={item.type} 
                                                        value={item.type}
                                                    >
                                                        {item.type}
                                                    </IonSelectOption>)
                                            }) }
                                        </IonSelect>
                                    </IonItem>
                                }
                                { ( (this.props.currentType === "import") || (this.props.currentType === "export" && (this.state.exportType === "Plain Text" || this.state.exportType === ".TXT")) ) &&
                                    <IonItem>
                                        <IonLabel>{window.ln.rowSeparator}</IonLabel>
                                        <IonInput value={this.state.rowSeparator} onIonChange={(e) => {
                                            this.setState({ rowSeparator: e.target.value }, function() {
                                                if (this.props.currentType === "export")
                                                    this.output()
                                                else
                                                    this.input();
                                            } ) }}></IonInput>
                                    </IonItem>
                                }
                                { ( (this.props.currentType === "import") || (this.props.currentType === "export" && (this.state.exportType === "Plain Text" || this.state.exportType === ".TXT")) ) &&
                                    <IonItem>
                                        <IonLabel>{window.ln.termDefSeparator}</IonLabel>
                                        <IonInput value={this.state.termDefinitionSeparator} onIonChange={(e) => {
                                            this.setState({ termDefinitionSeparator: e.target.value }, function() {
                                                if (this.props.currentType === "export")
                                                    this.output()
                                                else
                                                    this.input();
                                            } ) }}></IonInput>
                                    </IonItem>
                                }
                           </IonList>
                       </div>
                        { ( this.props.currentType === "import" || (this.props.currentType === "export" && this.state.exportType === "Plain Text") ) &&
                        <IonItem>
                                <IonLabel position="stacked">{this.props.currentType === "export" ? window.ln.output : window.ln.inputCards }</IonLabel>
                                <IonTextarea
                                    value={this.state.raw}
                                    rows={6}
                                    cols={20}
                                    onIonChange={(e) => { if (this.props.currentType === "import") this.setState({ raw: e.target.value }, function() { this.input(); }) }}
                                >
                                </IonTextarea>
                            </IonItem>
                        }
                       { (this.state.status) &&
                            <div>
                                <p className={"status" + ((!this.state.status.success) ? " error" : "")}>{this.state.status.data}</p>
                                { (this.state.status.data.indexOf("ready") !== -1) &&
                                    <div className="preview">
                                        <h2>{window.ln.importPreview}</h2>
                                        <div>
                                            { this.state.newCards.map(item => {
                                                return (
                                                    <div className="flashcard ioncard">
                                                        <h3>{item.term || "-"}</h3>
                                                        <p>{item.definition || "-"}</p>
                                                    </div>
                                                )
                                            }) }
                                        </div>
                                    </div>
                                }
                            </div>
                       }
                   </div>
               }
                <IonFab style={{ width: '100%' }} vertical="bottom" horizontal="start" slot="fixed">
                    { (this.props.currentType === "export" && this.state.exportType === "Plain Text") &&
                        <IonFabButton onClick={() => { this.copyToClipboard(); }} style={{ width: 'calc(100% - 20px)', '--border-radius': '56px' }}>
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{this.state.copyToClipboardText}</IonLabel>
                        </IonFabButton>
                    }
                    { (this.props.currentType === "export" && this.state.exportType !== "Plain Text") &&
                        <IonFabButton onClick={() => { this.generateFile(); }} style={{ width: 'calc(100% - 20px)', '--border-radius': '56px' }}>
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{this.state.generateFileText}</IonLabel>
                        </IonFabButton>
                    }
                    { (this.props.currentType === "import") &&
                        <IonFabButton disabled={this.state.importing} onClick={() => { this.import(); }} style={{ width: 'calc(100% - 20px)', '--border-radius': '56px' }}>
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{!this.state.import ? window.ln.import : window.ln.importing }</IonLabel>
                        </IonFabButton>
                    }
                </IonFab>
           </IonModal>
        );
    }

};


export default withIonLifeCycle(ExportImportModal);
